import { FunctionComponent, useEffect } from "react";
import { useTranslation } from "react-i18next";

import {
  RoleAssignmentUpdates,
  SecurityGroupRoleAssignmentsReadModel,
  StringReferenceReadModel,
} from "../../../../../../@api/index.ts";

import { translationKeys } from "../../../../../models/app-translation-keys.ts";
import { useAppRolesService } from "../../../../../services/ServiceHooks/appRolesHook.ts";
import { sharedDialog } from "../../../../Shared/Components/Dialogs/SharedDialog";
import { ManageSecurityGroupDialogContent } from "./ManageSecurityGroupDialogContent.tsx";
import { manageSecurityGroupDialogFooterActions } from "./manageSecurityGroupDialogFooterActions.ts";

import "../../../../Shared/Form/Layout/FormGridLayout.scss";

import { IManageSecurityGroupDialogState } from "./manageSecurityGroupDialogTypes.ts";

interface IManageSecurityGroupDialogProps {
  isVisible: boolean;
  onHide(addedSecurityGroup?: SecurityGroupRoleAssignmentsReadModel): void;
  existingSecurityGroupIds?: string[];
  roles?: StringReferenceReadModel[];
  data?: SecurityGroupRoleAssignmentsReadModel;
}

export const ManageSecurityGroupDialog: FunctionComponent<IManageSecurityGroupDialogProps> = (
  props: IManageSecurityGroupDialogProps,
) => {
  const { t } = useTranslation();
  const appRoleService = useAppRolesService();

  const manageDialogTranslationsKeys = translationKeys.adminArea.appRoles.dialog;

  useEffect(() => {
    if (!props.isVisible) {
      return;
    }

    sharedDialog.openSharedDialog({
      title: t(!props.data ? manageDialogTranslationsKeys.header.add : manageDialogTranslationsKeys.header.edit),
      size: "small",
      onClose: () => props.onHide(),
      sharedState: {
        isValid: false,
        hasPendingChanges: false,
        isUpdating: false,
      } satisfies IManageSecurityGroupDialogState,
      customContent: (
        <ManageSecurityGroupDialogContent
          data={props.data}
          existingSecurityGroupIds={props.existingSecurityGroupIds}
          roles={props.roles}
        />
      ),
      footerActions: manageSecurityGroupDialogFooterActions({
        data: props.data,
        onHide: props.onHide,
        isEdit: Boolean(props.data),
        updateRoleAssignments: async (requestBody: { [key: string]: RoleAssignmentUpdates }) =>
          appRoleService.updateRoleAssignments({ requestBody }),
      }),
      className: "add-edit-security-group-roles-dialog",
      customDismissBehavior: { closeIcon: true, escape: false, outsideClick: false },
    });
  }, [props.isVisible]);

  return null;
};
